import api from '../../api';

export interface QrCodeInfo {
  medialinkIds: string[];
  moduleId: string;
  id: string;
  name: string;
}

export async function getQrCodeInfoById(qrCodeId: string): Promise<QrCodeInfo> {
  const { data } = await api.get(`studio/qr/${qrCodeId}`);
  return data;
}
